export const ROUTES = {
  LOGIN: '/login',
  HOME: '/',
}

export const QUERIES = {
  POINT_ID: 'pointId',
  LOCATION_ID: 'locationId',
  EVENT_ID: 'eventId',
  COUNTRY_CODE: 'countryCode',
}
